// extracted by mini-css-extract-plugin
module.exports = {"link":"TextLink_link__vR5M7","on-light":"TextLink_on-light__3EP19","on-dark":"TextLink_on-dark__tZQVi","neutral":"TextLink_neutral__YU8ml","bold":"TextLink_bold__Hqr3D"};